import { create } from 'zustand';

type ObjectType = {
    id: string;
    name: string;
    localObject?: boolean;
    flowId?: string;
    text: Array<{
        id: string;
        text: string;
    }>;
};

type ObjectStore = {
    objects: ObjectType[];
    setObjects: (objects: ObjectType[] | undefined) => void;
    updateObject: (objectId: string, updatedObject: ObjectType) => void;
    addObject: (object: ObjectType) => void;
    removeObject: (objectId: string) => void;
};

export const useObjectStore = create<ObjectStore>((set) => ({
    objects: [],
    setObjects: (objects) => set({ objects: objects || [] }),
    updateObject: (objectId, updatedObject) =>
        set((state) => ({
            objects: state.objects.map((obj) =>
                obj.id === objectId ? { ...obj, ...updatedObject } : obj
            ),
        })),
    addObject: (object) =>
        set((state) => ({
            objects: [...state.objects, object],
        })),
    removeObject: (objectId) =>
        set((state) => ({
            objects: state.objects.filter((obj) => obj.id !== objectId),
        })),
})); 